import { render, staticRenderFns } from "./edit-article.vue?vue&type=template&id=64889c9b&"
import script from "./edit-article.vue?vue&type=script&lang=ts&"
export * from "./edit-article.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-article.vue"
export default component.exports